.section {
  border-top: 3px solid transparent;
  display: grid;
  grid-template-columns: 180px 1fr;
  background-image: linear-gradient(var(--border), var(--border));
  background-size: 1px 100%;
  background-position: 180px 0;
  background-repeat: no-repeat;
}

.blue   { border-top-color: #1a73e8; }
.teal   { border-top-color: #00897b; }
.amber  { border-top-color: #f9ab00; }
.purple { border-top-color: #7b57d6; }
.red    { border-top-color: #c5221f; }

/* Left sidebar — icon, title, subtitle */
.sidebar {
  padding: 24px 18px 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.iconBox {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon_blue   { background: #e8f0fe; color: #1a73e8; }
.icon_teal   { background: #e0f2f1; color: #00897b; }
.icon_amber  { background: #fef7e0; color: #e37400; }
.icon_purple { background: #ede7f6; color: #7b57d6; }
.icon_red    { background: #fce8e6; color: #c5221f; }

.title {
  font-size: 15px;
  font-weight: 600;
  color: var(--ink);
}

.subtitle {
  font-size: 13px;
  color: var(--muted);
  line-height: 1.5;
}

/* Right content area */
.content {
  padding: 24px 28px 28px;
}
